import Vue from 'vue'
import Router from 'vue-router'

export const TargetRoutes = [
  {
    path: '/',
    name: 'HelloWorld',
    NavigationBar: false,
    component: () => import(`@/components/HelloWorld.vue`)
  },
  {
    path: '/what/contest',
    name: 'WhatContest',
    NavigationBar: true,
    component: () => import(`@/components/WhatContest.vue`)
  },
  {
    path: '/auth/login',
    name: 'Login',
    NavigationBar: true,
    component: () => import(`@/components/auth/Login.vue`)
  },
  {
    path: '/auth/logout',
    name: 'Logout',
    NavigationBar: true,
    component: () => import(`@/components/auth/Logout.vue`)
  },
  {
    path: '/auth/register',
    name: 'Register',
    NavigationBar: true,
    component: () => import(`@/components/auth/Register.vue`)
  },
  {
    path: '/auth/add',
    name: 'UserAdd',
    NavigationBar: true,
    component: () => import(`@/components/auth/Add.vue`)
  },
  {
    path: '/auth/register_success',
    name: 'RegisterSuccess',
    NavigationBar: true,
    component: () => import(`@/components/auth/RegisterSuccess.vue`)
  },
  {
    path: '/auth/verify',
    name: 'EmailVerify',
    NavigationBar: true,
    component: () => import(`@/components/auth/EmailVerify.vue`)
  },
  {
    path: '/user',
    name: 'UserTop',
    NavigationBar: true,
    component: () => import(`@/components/user/Top.vue`)
  }
  // {
  //   path: '/user/upload',
  //   name: 'Upload',
  //   NavigationBar: true,
  //   component: () => import(`@/components/user/Upload.vue`)
  // }
]

// router読み込み
Vue.use(Router)
export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: TargetRoutes
})



// WEBPACK FOOTER //
// ./src/router.js